<form class="fms-signature-step" [formGroup]="form" (ngSubmit)="tryItOut()">
  <div class="fms-signature-step-row">
    <vng-input
      label="First Name"
      placeholder="First Name"
      type="text"
      [formControl]="form.controls['first_name']"
      [flyMsgIgnore]="true"
      [error]="
        !form.controls['first_name'].touched
          ? ''
          : form.controls['first_name'].hasError('required')
            ? 'First name is required'
            : form.controls['first_name'].hasError('pattern')
              ? 'Numbers not allowed.'
              : ''
      "
      data-fms-heap="walk-me-modal-signature-first-name"
    ></vng-input>
    <vng-input
      label="Last Name"
      placeholder="Last Name"
      type="text"
      [formControl]="form.controls['last_name']"
      [flyMsgIgnore]="true"
      [error]="
        !form.controls['last_name'].touched
          ? ''
          : form.controls['last_name'].hasError('required')
            ? 'Last name is required'
            : form.controls['last_name'].hasError('pattern')
              ? 'Numbers not allowed.'
              : ''
      "
      data-fms-heap="walk-me-modal-signature-last-name"
    ></vng-input>
  </div>

  <div class="fms-signature-step-row">
    <vng-input
      label="Title"
      placeholder="[insert title]"
      type="text"
      [formControl]="form.controls['title']"
      [flyMsgIgnore]="true"
      data-fms-heap="walk-me-modal-signature-title"
    ></vng-input>
    <vng-input
      label="Company"
      placeholder="[insert company name]"
      type="text"
      [formControl]="form.controls['company_name']"
      [flyMsgIgnore]="true"
      data-fms-heap="walk-me-modal-signature-company"
    ></vng-input>
  </div>

  <div class="fms-signature-step-row">
    <vng-input
      label="Phone"
      placeholder="[insert phone number]"
      type="text"
      [formControl]="form.controls['phone_number']"
      [flyMsgIgnore]="true"
      [error]="!form.controls['phone_number'].touched ? '' : form.controls['phone_number'].hasError('pattern') ? 'Invalid phone number' : ''"
      data-fms-heap="walk-me-modal-signature-phone"
    ></vng-input>
    <vng-input
      label="Email"
      placeholder="Email"
      type="text"
      [formControl]="form.controls['email']"
      [flyMsgIgnore]="true"
      [error]="
        !form.controls['email'].touched
          ? ''
          : form.controls['email'].hasError('required')
            ? 'Email is required'
            : form.controls['email'].hasError('email')
              ? 'Email is invalid'
              : ''
      "
      data-fms-heap="walk-me-modal-signature-email"
    ></vng-input>
  </div>

  <p *ngIf="loadFailed" class="fms-signature-step-error">
    We couldn't load your profile right now — you can still fill this in and try it out.
  </p>

  <div class="fms-signature-step-cta-row">
    <button
      vng-button
      variant="accent"
      type="submit"
      style="width: 110px"
      [disabled]="!canTryItOut"
      data-fms-heap="walk-me-modal-signature-try-it-out"
    >
      Try it out
    </button>
  </div>
</form>
